class MobileDrawer extends HTMLElement {
  constructor() {
    super();
    this.showDrawer = this.showDrawer.bind(this);
    this.hideDrawer = this.hideDrawer.bind(this);

    this.handleDropdowns = this.handleDropdowns.bind(this);
  }

  connectedCallback() {
    this.mobileDrawer = this.querySelector(".bosMobileDrawerContainer");
    this.bosHeaderMain = document.querySelector(".bosHeaderMain");
    this.bindEvents();
  }

  disconnectedCallback() {
    // escape key
    if (!this._escapeBound) {
      this._escapeHandler = (e) => {
        if (e.key === "Escape") this.hideDrawer();
      };
      document.removeEventListener("keydown", this._escapeHandler);
      this._escapeBound = true;
    }

    if (this.mobileDrawerButton) {
      this.mobileDrawerButton.removeEventListener("click", this.showDrawer);
    }

    // overlay
    if (this.drawerOverlay) {
      this.drawerOverlay.removeEventListener("click", this.hideDrawer);
    }

    if (this.closeButton) {
      this.closeButton.removeEventListener("click", this.hideDrawer);
    }
  }

  bindEvents() {
    // escape key
    if (!this._escapeBound) {
      this._escapeHandler = (e) => {
        if (e.key === "Escape") this.hideDrawer();
      };

      document.addEventListener("keydown", this._escapeHandler);
      this._escapeBound = true;
    }

    // menu cart drawer button
    this.mobileDrawerButton = document.querySelector(".bosHeaderMenuBtn");
    if (this.mobileDrawerButton) {
      this.mobileDrawerButton.addEventListener("click", this.showDrawer);
    }

    // overlay
    this.drawerOverlay = this.querySelector(".bosMobileDrawerOverlay");
    if (this.drawerOverlay) {
      this.drawerOverlay.addEventListener("click", this.hideDrawer);
    }

    // mini cart close button
    this.closeButton = this.querySelector(".bosMobileDrawerClose");
    if (this.closeButton) {
      this.closeButton.addEventListener("click", this.hideDrawer);
    }

    this.bosMobileDrawerDropdowns = this.querySelectorAll(
      ".bosMobileDrawerDropdowns",
    );
    if (this.bosMobileDrawerDropdowns) {
      this.bosMobileDrawerDropdowns.forEach((btn) =>
        btn.addEventListener("click", this.handleDropdowns),
      );
    }
  }

  handleDropdowns(e) {
    const target = e.currentTarget;
    const dropdown = target.querySelector(".bosMobileDrawerDropdown");

    this.querySelectorAll(".bosMobileDrawerDropdown").forEach((d) => {
      if (d !== dropdown) d.classList.add("hidden");
    });

    dropdown.classList.toggle("hidden");
  }

  showDrawer() {
    this.disableScrollingBody();
    if (this.drawerOverlay) this.drawerOverlay.classList.remove("hidden");
    if (this.mobileDrawer) this.mobileDrawer.classList.add("isOpen");
    this.mobileDrawer?.classList.add("isActiveDrawer");
    this.bosHeaderMain?.classList.add("hidden");
  }

  hideDrawer() {
    this.enableScrollingBody();
    if (this.drawerOverlay) this.drawerOverlay.classList.add("hidden");
    if (this.mobileDrawer) this.mobileDrawer.classList.remove("isOpen");
    this.mobileDrawer?.classList.remove("isActiveDrawer");
    this.bosHeaderMain?.classList.remove("hidden");
  }

  disableScrollingBody() {
    document.body.classList.add("disableScrolling");
  }

  enableScrollingBody() {
    document.body.classList.remove("disableScrolling");
  }
}

if (!customElements.get("mobile-drawer")) {
  customElements.define("mobile-drawer", MobileDrawer);
}
